import $global from './global';

let win = {};

if ($global.window) {
  win = $global.window;
}

const $window = win;

export default $window;
